import PricingPage from '../components/public-pages/PricingPage';

export default function SubscriptionPage() {
  return <PricingPage />;
}
